const CheckboxDropdownItem = (props: {
    id: string;
    name: string;
    label: string;
    value: string;
    selectedValues: string[];
    onValueSelected: Function;
}) => {
    return (
        <li>
            <a className="dropdown-item">
                <div className="form-check text-dark">
                    <input type="checkbox" className="form-check-input" id={props.id} name={props.name} value={props.value || ""} checked={props.selectedValues.indexOf(props.value) > -1} onChange={(e) => props.onValueSelected(props.label, e.target.value)} />
                    <label htmlFor={props.id} className="form-check-label">
                        {props.label}
                    </label>
                </div>
            </a>
        </li>
    );
};

export default CheckboxDropdownItem;
